// crm namespace — Erase / delete / unsubscribe dialogs (Loi 25 / GDPR).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "privacy.also": "l'adresse est ajoutée à la liste d'exclusion",
    "privacy.alsoLabel": "Aussi :",
    "privacy.delete": "Supprimer",
    "privacy.deleteBody": "La fiche CRM, son historique et ses notes sont supprimés. Les reçus et les réservations restent. Pour une demande d'effacement, utilisez plutôt « Effacer les données du client ».",
    "privacy.deleteTitle": "Supprimer {name} ?",
    "privacy.deleted": "Client supprimé",
    "privacy.erase": "Effacer",
    "privacy.eraseTitle": "Effacer les données de {name} ?",
    "privacy.erased": "Données du client effacées",
    "privacy.erasedBody": "Les données personnelles de ce client ont été effacées. Seuls les totaux d'achats anonymisés restent, pour la comptabilité.",
    "privacy.erasedTitle": "Client effacé",
    "privacy.typeToConfirm": "Saisissez « {name} » pour confirmer",
    "privacy.unsubscribe": "Désabonner",
    "privacy.unsubscribeBody": "Les e-mails marketing et les séquences s'arrêtent pour ce client. Les rappels de séance continuent.",
    "privacy.unsubscribeTitle": "Désabonner {name} ?",
    "privacy.unsubscribed": "Client désabonné",
    "privacy.willDelete": "champs personnels, notes de séance, réponses d'accueil, historique des e-mails",
    "privacy.willDeleteLabel": "Sera supprimé :",
    "privacy.willRemain": "les totaux d'achats anonymisés pour la comptabilité",
    "privacy.willRemainLabel": "Sera conservé :",
  },
  en: {
    "privacy.also": "email added to suppression list",
    "privacy.alsoLabel": "Also:",
    "privacy.delete": "Delete",
    "privacy.deleteBody": "The CRM record, its timeline and notes are removed. Receipts and bookings stay. To honour an erasure request, use Erase client data instead.",
    "privacy.deleteTitle": "Delete {name}?",
    "privacy.deleted": "Client deleted",
    "privacy.erase": "Erase",
    "privacy.eraseTitle": "Erase {name}'s data?",
    "privacy.erased": "Client data erased",
    "privacy.erasedBody": "This client's personal data was erased. Only anonymized purchase totals remain, for accounting.",
    "privacy.erasedTitle": "Erased client",
    "privacy.typeToConfirm": "Type \"{name}\" to confirm",
    "privacy.unsubscribe": "Unsubscribe",
    "privacy.unsubscribeBody": "Marketing emails and sequences stop for this client. Session reminders still send.",
    "privacy.unsubscribeTitle": "Unsubscribe {name}?",
    "privacy.unsubscribed": "Client unsubscribed",
    "privacy.willDelete": "personal fields, session notes, intake responses, email history",
    "privacy.willDeleteLabel": "Will be deleted:",
    "privacy.willRemain": "anonymized purchase totals for accounting",
    "privacy.willRemainLabel": "Will remain:",
  },
  es: {
    "privacy.also": "el correo se añade a la lista de exclusión",
    "privacy.alsoLabel": "Además:",
    "privacy.delete": "Eliminar",
    "privacy.deleteBody": "Se eliminan la ficha del CRM, su historial y sus notas. Los recibos y las reservas se conservan. Para una solicitud de borrado, usa «Borrar los datos del cliente».",
    "privacy.deleteTitle": "¿Eliminar a {name}?",
    "privacy.deleted": "Cliente eliminado",
    "privacy.erase": "Borrar",
    "privacy.eraseTitle": "¿Borrar los datos de {name}?",
    "privacy.erased": "Datos del cliente borrados",
    "privacy.erasedBody": "Los datos personales de este cliente se borraron. Solo quedan los totales de compras anonimizados, para la contabilidad.",
    "privacy.erasedTitle": "Cliente borrado",
    "privacy.typeToConfirm": "Escribe «{name}» para confirmar",
    "privacy.unsubscribe": "Dar de baja",
    "privacy.unsubscribeBody": "Los correos de marketing y las secuencias se detienen para este cliente. Los recordatorios de sesión siguen.",
    "privacy.unsubscribeTitle": "¿Dar de baja a {name}?",
    "privacy.unsubscribed": "Cliente dado de baja",
    "privacy.willDelete": "datos personales, notas de sesión, respuestas de admisión, historial de correos",
    "privacy.willDeleteLabel": "Se eliminará:",
    "privacy.willRemain": "los totales de compras anonimizados para la contabilidad",
    "privacy.willRemainLabel": "Se conservará:",
  },
};
